
import React from "react";
import FormField from "@/components/forms/FormField";

interface ContactInfoSectionProps {
  website: string;
  phone: string;
  email: string;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
  formErrors: Record<string, string>;
}

const ContactInfoSection: React.FC<ContactInfoSectionProps> = ({
  website,
  phone,
  email,
  handleChange,
  formErrors,
}) => {
  return (
    <>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <FormField
          id="website"
          label="Website"
          type="url"
          value={website}
          onChange={handleChange}
          error={formErrors.website}
          placeholder="https://example.com"
        />

        <FormField
          id="phone"
          label="Phone Number"
          type="tel"
          value={phone}
          onChange={handleChange}
          error={formErrors.phone}
        />
      </div>

      <FormField
        id="email"
        label="Email"
        type="email"
        value={email}
        onChange={handleChange}
        error={formErrors.email}
      />
    </>
  );
};

export default ContactInfoSection;
